import FullScreen from './full-screen';

export default FullScreen;
